export default "__VITE_ASSET__DCfFxp74__"